var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-2"},[_c('div',{staticClass:"profile-pic-sheet",style:({ backgroundImage: `url(${_vm.source})` })}),(_vm.accountActive)?_c('div',{staticClass:"profile-active"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }